import { toast } from "sonner";
import { Printer } from "lucide-react";
import { openPdf } from "@/lib/documents";
import { BTN_SECONDARY, BTN_SM } from "@/components/checkout/buttonStyles";
import { DownloadPdfButton } from "./DownloadPdfButton";
import { requestRegCard } from "./RegCardOptions";

/** Toast shown after a document is issued: [Print] [Download] instead of auto-opening a tab (popup-safe). regCard → asks "Show Rates?" first. */
export function notifyDocument(title, { description, url, filename, testId = "doc-toast", duration = 15000, regCard = false } = {}) {
  toast.success(title, {
    duration,
    description: (
      <div className="mt-1 space-y-2" data-testid={testId}>
        {description && <div className="text-[12px] text-[#3F5257]">{description}</div>}
        <div className="flex flex-wrap gap-1.5">
          <button type="button" className={`${BTN_SECONDARY} ${BTN_SM}`} onClick={() => (regCard ? requestRegCard({ url, filename }) : openPdf(url, filename))} data-testid={`${testId}-print`}><Printer size={13} />Print</button>
          <DownloadPdfButton url={url} filename={filename} regCard={regCard} testId={`${testId}-download`} />
        </div>
      </div>
    ),
  });
}
